var _ = require("lodash");
module.exports = _.reduce(["id", "owner"], function (a, v, k) {
  a[v] = k;
  return a;
}, {});